import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Context, ContextMembership, LaboratorySample, NetworkConstants } from 'diwimamodelweb/lib';
import { diffObject, updatesToFirestoreUpdates } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BehaviorSubject, Subject, Subscription, combineLatest } from 'rxjs';
import { skipWhile, take, takeUntil } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { deepCopy,removeUndefined } from 'diwimamodelweb/lib';
import { Firestore, deleteDoc, doc, updateDoc, collection, where, collectionData, query, or } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class LabSampleService {
  private Ifirestore = inject(Firestore);

  ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: Map<string, Subscription> = new Map([])

  labSampleSubject$ = new BehaviorSubject<LaboratorySample[]>(undefined)
  subbedContext: string|undefined = undefined

  constructor(
    private settingsService: SettingsService,
    private firestore: AngularFirestore,
    private userService: UserService,
    private transactionLogService: TransactionLogService
  ) {
    // this.settingsService.selectedUserContext$.pipe(
    //   // skipWhile(el => !el),
    //   // map(el => el.identifier)
    // ).subscribe((context) => {
    //   if (!context) {
    //     this.subbedContext = undefined
    //     return 
    //   }
    //   if (this.subbedContext?.identifier == context.identifier) return 
    //   if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    //   this.labSampleSubject$.next(undefined)
    //   const sub = this.observeLaboratorySamples(context)
    //   this.subscriptions.set('1', sub)
    //   this.subbedContext = context
    // })
  }

  observeData(dataFromIds) {
    const contextId = this.settingsService.selectedUserContext$.value?.identifier
    // console.log(' --- observeData labSample ---', this.subbedContext, dataFromIds)
    if (this.subbedContext == dataFromIds) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.labSampleSubject$.value) this.labSampleSubject$.next(undefined)

    const superOrsubContext = this.settingsService.superContext.value || this.settingsService.subContext.value
    if (superOrsubContext) {
      const context = this.settingsService.selectedUserContext$.value
      const subIds = this.settingsService.getSubcontextIds()// this.settingsService.selectedUserContext$.value.subContextIds
      const sub = this.observeLaboratorySamplesContextAndContextIds(contextId, subIds, context)
      this.subscriptions.set('1', sub)
    } else {
      const sub = this.observeLaboratorySamples(contextId)
      this.subscriptions.set('1', sub)
    }

    this.subbedContext = superOrsubContext ? dataFromIds : contextId
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    return Promise.resolve()
  }

  resetData() {
    this.labSampleSubject$.next(null)
  }

  observeLaboratorySamples(contextId: string) {
    // return this.firestore.collection(NetworkConstants.COLLECTION_LABSAMPLE, ref => ref.where('contextId', "==", contextId)).valueChanges()
    const path = `${NetworkConstants.COLLECTION_LABSAMPLE}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId));

      return collectionData(q)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(async (values: any[]) => {
        // values to person 
        var list: LaboratorySample[] = []
        const context = await this.settingsService.selectedUserContext$.pipe(
          skipWhile(el => !el),
          take(1)
        ).toPromise()
        values.forEach((element: any) => {
          const labSample = new LaboratorySample(context)
          labSample.setFromAny(element)
          list.push(labSample)
        })
        this.labSampleSubject$.next(list)
      })
  }


  observeLaboratorySamplesContextAndContextIds(contextId: string, contextIds: string[], context) {
    // console.log('--- observeLaboratorySamplesContextAndContextIds ---', contextId, contextIds)
    const path = `${NetworkConstants.COLLECTION_LABSAMPLE}`
    const collRef = collection(this.Ifirestore, path);
    const CHUNK_SIZE = 30;
    const qy$ = [];

    qy$.push(collectionData(query(collRef, where('contextId', '==', contextId))));
    qy$.push(collectionData(query(collRef, where('contextIds', 'array-contains', contextId))));

    if (contextIds?.length != 0) {
      for (let i = 0; i < contextIds.length; i += CHUNK_SIZE) {
        const chunk = contextIds.slice(i, i + CHUNK_SIZE);
        qy$.push(collectionData(query(collRef, where('contextId', 'in', chunk))));
    
      }
    }

    return combineLatest(...qy$)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe( {

      next: (results: any[][]) => {
        var list: LaboratorySample[] = []
        results
        .flat()
        .forEach((el) => {
          const labSample = new LaboratorySample(context)
          labSample.setFromAny(el)
          list.push(labSample)
        });

        this.labSampleSubject$.next(list)
      },
      error: (err) => {
        console.error("Firestore error:", err);
      }
      
    });
  }

  updateLabSample(oldLabSample: LaboratorySample, newLabSample: LaboratorySample): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldLabSample, newLabSample, {})
      const map = updatesToFirestoreUpdates(updates)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newLabSample.identifier, NetworkConstants.COLLECTION_LABSAMPLE)
        map['updateTimestamp'] = new Date()
        // await this.firestore.collection(NetworkConstants.COLLECTION_LABSAMPLE).doc(newLabSample.identifier).update(map)
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_LABSAMPLE, newLabSample.identifier)
        await updateDoc( docRef, map)
        // if successfull save transactionlog..
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  deleteLabSample(labSample: LaboratorySample): Promise<void>{
    return new Promise(async (resolve, reject) => {
      try{
        const gToDelete = deepCopy(labSample, labSample.replacerFn)
        const dataToDelete = removeUndefined(gToDelete)
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          labSample.identifier,
          NetworkConstants.COLLECTION_LABSAMPLE,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_LABSAMPLE, labSample.identifier)
        const delOperation = await deleteDoc( docRef)
        // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_LABSAMPLE).doc(labSample.identifier).delete()
        promiseArray.push(delOperation)
        resolve()
      }catch(error){
        reject(error)
        console.log(error)
      }
    })
  }


}
